stateProviders.push({
    name: 'schoolside.settings.parentApp.addendumLetter',
    url: '/addendumLetter',
    templateUrl: "fast/submodules/schoolside/settings/parentApp/addendumLetter/partials/addendumLetter.html?v=" + versionNo,
    controller: 'AddendumLetterController',
    resolve: {
        wolf: function(ModelService)
        {
            return ModelService.helpSystem.resolveData('?script=scSinAl');
        },
        gang: function(SchoolAddendumModelService, authServiceFactory)
        {
            return SchoolAddendumModelService.get(authServiceFactory.getAuth().schoolID);
        }
    }
});